import { useQuery } from "@tanstack/react-query";
import { getProjectById } from "../../services/projectDetailsApi";
import { mapProjectDetailsResponse } from "./projectDetails.utils";

export const PROJECT_DETAILS_QUERY_KEY = (projectId) => ["project", projectId];

/** Fetches and maps a single project's details; only runs once a projectId is available. */
export function useProjectDetailsQuery(projectId) {
  return useQuery({
    queryKey: PROJECT_DETAILS_QUERY_KEY(projectId ?? ""),
    queryFn: () => getProjectById(projectId),
    enabled: Boolean(projectId),
    select: mapProjectDetailsResponse,
    staleTime: 0,
    refetchOnMount: "always",
  });
}
